import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "reset-password-form" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "mt-2 w-35 ly-container large-number-container mfa-input-container" }
const _hoisted_4 = {
  key: 0,
  class: "msg msg-error w-100 text-center"
}
const _hoisted_5 = { class: "ly-row mt-2 ly-even-2" }

import { inject, ref } from 'vue'
import { Redirect } from '@/types/redirect'
import { EnrollmentResponse, MFAChallengeInput, getState, resetRedirectAfterMFA } from '@/services/mfa'
import { AuthenticationResult } from '@/types/authenticationResult'


export default /*@__PURE__*/_defineComponent({
  __name: 'MfaSmsConfirmForm',
  setup(__props) {

const verifyEnrollmentSMS = inject('verifyEnrollmentSMS') as ({ username, session, code }: Omit<MFAChallengeInput, 'access_token'>) => Promise<EnrollmentResponse>
const redirectToRetrieveToken = inject('redirectToRetrieveToken') as (authenticationResult: AuthenticationResult) => Promise<void>

const redirect = inject('redirect') as Redirect
const { authenticationResult, username, session, sentTo } = getState()
const code = ref('')
const isSubmitting = ref(false)
const errorMessage = ref('')

const goBack = () => {
  redirect('LoginView')
}

const verify = async (event: Event) => {
  event.preventDefault()
  isSubmitting.value = true
  errorMessage.value = ''

  const payload = {
    code: code.value.trim(),
    username,
    session
  }

  const { success } = await verifyEnrollmentSMS(payload)
  if (!success) {
    isSubmitting.value = false
    errorMessage.value = 'Invalid MFA Code. The code you entered is incorrect or has expired.'
  }

  isSubmitting.value = false

  resetRedirectAfterMFA()
  if (success && authenticationResult) redirectToRetrieveToken(authenticationResult)
}

return (_ctx: any,_cache: any) => {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_lp_button = _resolveComponent("lp-button")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "text-center" }, "Multi-factor Authentication", -1)),
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode("A code was sent to " + _toDisplayString(_unref(sentTo)) + ". ", 1),
      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
      _cache[2] || (_cache[2] = _createTextVNode("Enter the code below to verify. ", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
      _cache[4] || (_cache[4] = _createTextVNode("Standard messaging rates may apply. ", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_lp_input, {
        modelValue: code.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((code).value = $event)),
        "max-length": 6,
        compact: "",
        class: "text-center font-weight-bold",
        placeholder: "______"
      }, null, 8, ["modelValue"])
    ]),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        onClick: goBack,
        type: "button"
      }, "Cancel"),
      _createVNode(_component_lp_button, {
        onClick: verify,
        type: "primary",
        loading: isSubmitting.value,
        disabled: !code.value || code.value?.length !== 6 || isSubmitting.value
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createTextVNode("Verify", -1)
        ]))]),
        _: 1
      }, 8, ["loading", "disabled"])
    ])
  ]))
}
}

})